import { BrowserView, MobileView } from "react-device-detect";
import CameraBS from "./CameraBS";
import SearchResultsModal from "./SearchResultsModal";

const SearchOffCanvas = () => {
  return <>
    <BrowserView>
      <SearchResultsModal />
    </BrowserView>

    <MobileView>
      <CameraBS />
    </MobileView>
  </>
}

export default SearchOffCanvas;